import { render, staticRenderFns } from "./BookingConfirmationGenericError.vue?vue&type=template&id=77c7e730&scoped=true"
import script from "./BookingConfirmationGenericError.vue?vue&type=script&lang=js"
export * from "./BookingConfirmationGenericError.vue?vue&type=script&lang=js"
import style0 from "./BookingConfirmationGenericError.vue?vue&type=style&index=0&id=77c7e730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c7e730",
  null
  
)

export default component.exports